export const LIBPREFIX = 'amplitude-ts';
